import Component from './Component';

export default class BlogLegend extends Component {
  load() {
    // console.log('BlogLegend');

    const legendList = document.querySelector('.legend__list');
    const legendDropBtn = document.querySelector('.legend__dropbtn');

    legendDropBtn.addEventListener('click', () => {
      legendList.classList.toggle('legend__list--open');
    });

    super.load();

  }
}
